export interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  rating: number;
  text: string;
  date: string;
  approved: boolean;
}

const STORAGE_KEY = 'r3d_testimonials';

export function getTestimonials(): Testimonial[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
    return [];
  } catch {
    return [];
  }
}

export function saveTestimonials(testimonials: Testimonial[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(testimonials));
}

export function addTestimonial(testimonial: Omit<Testimonial, 'id' | 'approved' | 'date'>): void {
  const all = getTestimonials();
  const newOne: Testimonial = {
    ...testimonial,
    id: Date.now().toString(),
    date: new Date().toLocaleDateString('fr-FR'),
    approved: false,
  };
  saveTestimonials([...all, newOne]);
}

export function approveTestimonial(id: string): void {
  const all = getTestimonials();
  saveTestimonials(all.map(t => t.id === id ? { ...t, approved: true } : t));
}

export function deleteTestimonial(id: string): void {
  const all = getTestimonials();
  saveTestimonials(all.filter(t => t.id !== id));
}

export function getApprovedTestimonials(): Testimonial[] {
  return getTestimonials().filter(t => t.approved);
}
